"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "board-space-bonuses" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.bonus, (spaceBonus, idx) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("i", {
                key: idx,
                class: (0, vue_1.normalizeClass)(_ctx.getClass(idx + 1, spaceBonus))
            }, null, 2));
        }), 128))
    ]));
}
